import type { LumoraClient } from "@lumora/bridge";
import { SessionSecurityViewModel } from "@lumora/core";
import { MfaEnforcementBanner, SessionSecurityPanel, useViewModel } from "@lumora/ui";
import { useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";

export interface MfaSecuritySectionProps {
  client: Pick<LumoraClient, "mfaStatus" | "mfaDisable" | "revokeAllSessions">;
  /** Router path of the enrol screen. */
  enrollPath: string;
  /** Router path to land on after "Sign out everywhere". */
  signInPath: string;
}

/** Enforcement banner + sign-in security panel for a settings/dashboard page (#1501, #1525). */
export function MfaSecuritySection({ client, enrollPath, signInPath }: MfaSecuritySectionProps) {
  const navigate = useNavigate();
  const vm = useMemo(() => new SessionSecurityViewModel(client), [client]);
  const state = useViewModel(vm);
  useEffect(() => {
    void vm.load();
  }, [vm]);
  const enroll = (
    <Link className="lumora-mfa__primary" to={enrollPath}>
      Set up two-step sign-in
    </Link>
  );
  const status = state.status;
  return (
    <div data-lumora-view="mfa-security">
      <MfaEnforcementBanner
        enrollmentRequired={Boolean(status && !status.enabled && status.enrollment?.required)}
        graceEndsAt={status?.enrollment?.graceEndsAt}
        enrollAction={enroll}
      />
      <SessionSecurityPanel viewModel={vm} enrollAction={enroll} onSignedOut={() => navigate(signInPath, { replace: true })} />
    </div>
  );
}
